import { useRef } from 'react';
import { smoothScrollToPosition } from '../../../utils/smoothScrollToPosition';

export const useScroll = () => {
  const scrolledElementRef = useRef<HTMLDivElement>(null);

  const scrollToTop = () => smoothScrollToPosition(scrolledElementRef.current);

  return { scrolledElementRef, scrollToTop };
};
